module.exports = __webpack_public_path__ + "assets/aec0c3e65a55118f1bb2b8d3ff53a7fe.svg";